import React, { FunctionComponent } from "react";
import { IndexBarSharing } from "../../../Common/";
import { RetailMatchKeyMetricsWrapper } from "../Styled/RetailMatchKeyMetricsStyles";
import {
    IRetailMatchJobResult,
    IRetailMatchOverview,
    IStoreScoreRecord,
} from "../../../../Models/IRetailMatch";
import { RetailMatchMetricLevel } from "../../../../Enums/RetailMatchMetricLevel";
import { Header, HeaderFocusSharing } from "../Styled/RetailMatchIntroStyles";
import { getDateBackVerbiage } from "../../../../Util/RetailMatch/RetailMatchUtil";
import RetailMatchIntroTextIndexBreakout from "./RetailMatchIntroTextIndexBreakout";
import styled from "styled-components";

interface IKeyMetricsSharingContainer {
  inSidebar: boolean;
}

const KeyMetricsSharingContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${(props: IKeyMetricsSharingContainer) =>
        !props.inSidebar
    && `            
        height: 100%;
        padding-left: 113px;
    `}

  ${(props: IKeyMetricsSharingContainer) =>
        props.inSidebar
    && `            
        flex-grow: 0.5;
        justify-content: space-between;
    `}
`;

const KeyMetricsSharingWrapperContainer = styled.div`
  ${(props: IKeyMetricsSharingContainer) =>
        !props.inSidebar
    && `
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        flex: 0.9;
    `}
`;
interface RetailMatchKeyMetricsProps {
  brandName: string;
  jobOverview: IRetailMatchOverview;
  locationAddress: string;
  jobResult: IRetailMatchJobResult;
  inSidebar?: boolean;
}

export const RetailMatchKeyMetricsSharing: FunctionComponent<RetailMatchKeyMetricsProps>
  = ({
      brandName,
      jobOverview,
      inSidebar,
      locationAddress,
      jobResult,
  }: RetailMatchKeyMetricsProps) => {
      return (
          <KeyMetricsSharingContainer
              data-testid="key-metrics-sharing"
              inSidebar={inSidebar}
          >
              <Header
                  style={{
                      marginBottom: 14,
                      lineHeight: !inSidebar ? "1.5" : "initial",
                  }}
              >
                  <HeaderFocusSharing style={{ fontSize: inSidebar ? 13 : 20 }}>
                      {locationAddress}
                  </HeaderFocusSharing>
                  <div
                      style={{ fontSize: inSidebar ? 13 : 20, letterSpacing: "1.3px" }}
                  >
            COMPARED TO
                  </div>
                  <HeaderFocusSharing style={{ fontSize: inSidebar ? 13 : 20 }}>
                      {jobOverview.sampleCount.toLocaleString()} Existing Similar{" "}
                      {brandName} Locations
                  </HeaderFocusSharing>
                  {!inSidebar && (
                      <div
                          style={{ fontSize: 13, textAlign: "center", marginBottom: 28 }}
                      >
              based on analysis of consumer mobile device signals{" "}
                          {getDateBackVerbiage(
                              jobResult.job.startDate,
                              jobResult.job.endDate
                          )}
                      </div>
                  )}
              </Header>
              {!inSidebar && (
                  <div style={{ whiteSpace: "nowrap" }}>
                      <RetailMatchIntroTextIndexBreakout
                          overview={jobOverview}
                          isSharing={true}
                      />
                  </div>
              )}
              <KeyMetricsSharingWrapperContainer inSidebar={inSidebar}>
                  <RetailMatchKeyMetricsWrapper
                      style={{ display: "initial", margin: 0 }}
                  >
                      <IndexBarSharing
                          index={jobOverview.coreCustomerCountIndex}
                          title="Ideal Customer Count"
                          subTitle="How do counts of ideal households in the trade areas compare?"
                          scaleText={RetailMatchMetricLevel.Average}
                          inSidebar={inSidebar}
                      />
                  </RetailMatchKeyMetricsWrapper>
                  <RetailMatchKeyMetricsWrapper
                      style={{ display: "initial", margin: 0 }}
                  >
                      <IndexBarSharing
                          index={jobOverview.coreCustomerPerHouseholdIndex}
                          title="Ideal Customer Ratio"
                          subTitle="How does the ratio of ideal households to all households in the trade areas compare?"
                          scaleText={RetailMatchMetricLevel.Comparable}
                          inSidebar={inSidebar}
                      />
                  </RetailMatchKeyMetricsWrapper>
                  <RetailMatchKeyMetricsWrapper
                      style={{ display: "initial", margin: 0 }}
                  >
                      <IndexBarSharing
                          index={jobOverview.coreCustomerCorrelationIndex}
                          title="Ideal Customer Similarity"
                          subTitle="How similar is the mix of all households in the trade areas?"
                          scaleText={RetailMatchMetricLevel.Similarity}
                          inSidebar={inSidebar}
                      />
                  </RetailMatchKeyMetricsWrapper>
              </KeyMetricsSharingWrapperContainer>
          </KeyMetricsSharingContainer>
      );
  };
